(function($) {
  $(function() {

    var $slider = $('.content-slider .slider');

    $slider.addClass('no-hide').each(function(){

      var $this = $(this);

      imagesLoaded($this, function(){
        var slider = $this.sudoSlider({
          continuous:true,
          responsive:true,
          auto:false,
          autoHeight:true,
          speed:500,
          prevNext:true,
          moveCount: 1,
          slideCount: 1,
          touch: true,
          mouseTouch: false,
          insertAfter: false
        }),
        moves = [
          {
            min:0,
            max:767,
            enter: function() {
              slider.setOption('slideCount',1);
            },
            exit: function() {}
          },
          {
            min:768,
            max:1023,
            enter: function() {
              slider.setOption('slideCount',2);
            },
            exit: function() {}
          },
          {
            min:1024,
            max:99999,
            enter: function() {
              slider.setOption('slideCount',3);
            },
            exit: function() {}
          }
        ];

        breakdance(moves);

        $(window).on('resize.sliderPause',function(){ slider.stopAnimation() });
      });
    });

  });
})($JQ);
